import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { toast } from 'sonner';
import { recuentosAPI, errorMsg } from '@/lib/recuentos';

export const NuevoRecuentoDialog = ({ open, onOpenChange, lugares, basePath, defaultResponsable }) => {
  const navigate = useNavigate();
  const [lugar, setLugar] = useState('');
  const [responsable, setResponsable] = useState('');
  const [comentario, setComentario] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setLugar(lugares.length === 1 ? lugares[0].codigo : '');
      setResponsable(defaultResponsable || '');
      setComentario('');
    }
  }, [open, lugares, defaultResponsable]);

  const crear = async () => {
    if (!lugar) return toast.error('Elige el lugar a contar');
    setSaving(true);
    try {
      const { data } = await recuentosAPI.create({ lugar_codigo: lugar, responsable, comentario });
      onOpenChange(false);
      navigate(`${basePath}/${data.id}`);
    } catch (e) {
      toast.error(errorMsg(e, 'No se pudo crear el recuento'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="nuevo-recuento-dialog">
        <DialogHeader><DialogTitle>Nuevo recuento</DialogTitle></DialogHeader>
        <div className="space-y-4 py-2">
          <div>
            <Label>Lugar a contar</Label>
            <div className="grid gap-2 mt-2">
              {lugares.map((l) => (
                <button
                  key={l.codigo}
                  type="button"
                  onClick={() => setLugar(l.codigo)}
                  className={`rounded-xl border-2 px-4 py-3 text-left transition-colors ${
                    lugar === l.codigo ? 'border-orange-500 bg-orange-50' : 'border-slate-200 hover:border-orange-200'
                  }`}
                  data-testid={`nuevo-recuento-lugar-${l.codigo}`}
                >
                  <div className="font-semibold text-slate-800">{l.local}</div>
                  <div className="text-sm text-slate-500">{l.nombre_bodega_justo}</div>
                </button>
              ))}
            </div>
          </div>
          <div>
            <Label htmlFor="rec-responsable">Responsable</Label>
            <Input id="rec-responsable" value={responsable} onChange={(e) => setResponsable(e.target.value)} data-testid="nuevo-recuento-responsable" />
          </div>
          <div>
            <Label htmlFor="rec-comentario">Comentario (opcional)</Label>
            <Textarea id="rec-comentario" rows={2} value={comentario} onChange={(e) => setComentario(e.target.value)} data-testid="nuevo-recuento-comentario" />
          </div>
          <p className="text-xs text-slate-500">La fecha y hora se registran automáticamente. Si ya hay un borrador para ese lugar, se abrirá ese mismo.</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={crear} disabled={saving} className="bg-orange-500 hover:bg-orange-600" data-testid="nuevo-recuento-crear-btn">
            {saving ? 'Creando...' : 'Comenzar recuento'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
